/**
 * Volunteer roles drawer store
 *
 * Vanilla Zustand store for UI-only state in the profile drawer:
 * edit mode toggle and selected dropdown role.
 */

import { defineZustandStore } from "@/zustand-utils"

export type TermsStep = "initial" | "loading" | "success"

type VolunteerRolesDrawerState = {
  internalEdit: boolean
  selectedVolunteerRoleId: number | null
  showTermsDialog: boolean
  pendingRoleId: number | null
  termsStep: TermsStep
  showSecondStep: boolean
}

const initialState: VolunteerRolesDrawerState = {
  internalEdit: false,
  selectedVolunteerRoleId: null,
  showTermsDialog: false,
  pendingRoleId: null,
  termsStep: "initial",
  showSecondStep: false,
}

export const {
  store: volunteerRolesStore,
  set,
  useStoreWithSelector: useVolunteerRolesStore,
} = defineZustandStore({
  initialState,
  storeName: "VolunteerRolesDrawer",
})

export const VolunteerRolesActions = {
  toggleEdit: () => set((s) => ({ internalEdit: !s.internalEdit })),
  setSelectedVolunteerRoleId: (id: number | null) => set({ selectedVolunteerRoleId: id }),
  showTermsDialog: (roleId: number, secondStep: boolean) =>
    set({
      showTermsDialog: true,
      pendingRoleId: roleId,
      termsStep: "initial" as const,
      showSecondStep: secondStep,
    }),
  setTermsStep: (step: TermsStep) => set({ termsStep: step }),
  dismissTermsDialog: () =>
    set({
      showTermsDialog: false,
      pendingRoleId: null,
      termsStep: "initial" as const,
      showSecondStep: false,
    }),
  reset: () => set({ ...initialState }),
} as const
